class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    // NEW: Listen for cart updates globally (Standard for Dawn & modern Shopify themes)
    document.addEventListener('cart:updated', this.onCartUpdated.bind(this));
    
    // ALTERNATIVE NEW: For themes using standard AJAX api events
    document.addEventListener('ajaxProduct:added', this.onCartUpdated.bind(this));
  }

  // NEW: Fetch fresh HTML sections from Shopify's bundled AJAX API on change
  onCartUpdated(event) {
    // If your theme passes the new state in the event detail, use it. 
    // Otherwise, fetch the updated sections dynamically.
    const sections = this.getSectionsToRender().map(section => section.id).join(',');
    
    fetch(`${routes.cart_url || '/cart'}?sections=${sections}`)
      .then((response) => response.json())
      .then((parsedState) => {
        // We simulate the parsedState layout your render method expects
        this.renderContents({
          key: event?.detail?.key || this.cartItemKey,
          sections: parsedState
        });
      })
      .catch((e) => console.error('Cart notification update failed:', e));
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    // Fixed a potential bug: Ensure activeElement exists before stripping focus
    if (this.activeElement) removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      const element = document.getElementById(section.id);
      if (!element || !parsedState.sections[section.id]) return; // Guard clause

      element.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',

      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble', // This is what updates your count badge!
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    const parsedDOM = new DOMParser().parseFromString(html, 'text/html');
    const selectedElement = parsedDOM.querySelector(selector);
    return selectedElement ? selectedElement.innerHTML : parsedDOM.body.innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);